import { Box } from '@mui/material';
import { VideoComponentProps } from './Video.types';

export const VideoComponent = ({
  alternativeText,
  url,
  mime,
}: VideoComponentProps) => {
  if (!url) return null;

  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Box
        component="video"
        src={url}
        controls
        width="70%"
        sx={{
          borderRadius: '0.5rem',
          minHeight: {
            xs: 150,
            sm: 200,
            md: 300,
            lg: 500,
          },
        }}>
        <source src={url} type={mime || 'video/mp4'} />
        {alternativeText || 'Your browser does not support the video tag'}
      </Box>
    </Box>
  );
};
